module.exports = __webpack_public_path__ + "img/4.08.thmb.69229051.jpg";